import type { CookieSetOptions } from "universal-cookie"
import { getPreregCookieName } from "utils/get-prereg-cookie-name"
import { year } from "utils/time"
import type { PostRegData } from "./node-api/post-prereg"
import { postPrereg } from "./node-api/post-prereg"
import { trackFbq } from "./tracking"

export const PREREG_COMPLETED = "Completed!"

export const completePrereg = async (
  preregData: PostRegData,
  setCookie: (name: string, value: unknown, options?: CookieSetOptions | undefined) => void,
) => {
  try {
    const response = await postPrereg(preregData)
    if (response !== "Ok") {
      throw response
    }
    trackFbq("track", "CompleteRegistration")
    setPreregCookie(preregData.wallet, setCookie)
    return PREREG_COMPLETED
  } catch (error) {
    if (typeof error === "string" && error.includes("duplicate key value")) {
      setPreregCookie(preregData.wallet, setCookie)
      return "You are already pre-registered!"
    }
    return error + ""
  }
}

const setPreregCookie = (
  wallet: string,
  setCookie: (name: string, value: unknown, options?: CookieSetOptions | undefined) => void,
) => {
  setCookie(getPreregCookieName(wallet.toLowerCase()), 1, { maxAge: year, secure: true })
}
